export default "__VITE_ASSET__BE_SG6AO__"